module.exports = __webpack_public_path__ + "static/media/incident_switch_en.9964774d.png";